import React from 'react';

const HorizontalPillTabs = ({
  items = [],
  activeId,
  onSelect,
  className = '',
  getItemDisabled = () => false,
}) => {
  if (!Array.isArray(items) || items.length === 0) return null;

  return (
    <div className={`flex max-w-full gap-2 overflow-x-auto pb-1 ${className}`.trim()}>
      {items.map((item) => {
        const id = String(item.id);
        const isActive = String(activeId) === id;
        const disabled = getItemDisabled(item);
        return (
          <button
            key={id}
            type="button"
            onClick={() => {
              if (!disabled) onSelect?.(item.id);
            }}
            disabled={disabled}
            className={`px-3 py-1 rounded-full text-xs font-medium border whitespace-nowrap ${
              isActive
                ? 'bg-blue-600 text-white border-blue-600'
                : 'bg-white text-gray-600 border-gray-200 hover:border-blue-300'
            } ${disabled ? 'cursor-not-allowed opacity-60' : ''}`.trim()}
          >
            {item.label}
          </button>
        );
      })}
    </div>
  );
};

export default HorizontalPillTabs;
